/* eslint-disable import/no-unresolved */

import React from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

import shortid from 'shortid';
import { getSlugName } from '../../helpers/util';
import useCaseStudies from '../../graphql/staticQueries/useCaseStudies';

import ServicesHeading from '../../components/SoftwareServices/ServicesHeading';
import imagesPillarPages from '../../components/imagesPillarPages';
import imagesLandingPages from '../../components/imagesLandingPages';
import ResultsCardSwiperSection from '../../components/ResultsCardSwiperSection';
import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import ResultTestimonial from '../../components/Result/ResultTestimonial';
import ImgHTML from '../../components/ImgHTML';
import HomeKnowledge from '../../components/Home/HomeKnowledge';
import LandingPageInfoBox from '../../components/LandingPages/LandingPageInfoBox';
import OptimizedImage from '../../components/OptimizedImage';
import MultiCarousel from '../../components/Carousels/MultipleCarousel';
import SingleBox from '../../components/Careers/careersPartials/SingleBox';
import Banner from '../../components/service/Products/productsPartials/DevOpsBanner';
import Softwares from '../../components/SoftwareServices/Softwares';
import CheckmarkColumns from '../../components/SoftwareServices/CheckmarkColumns';
import TelecommunicationSection from '../../components/SoftwareServices/TelecommunicationSection';

import content from '../../components/SoftwareServices/content-blockchain-development';

const SoftwareServices = () => {
  const cases = useCaseStudies();
  const selectedCase = cases.find(caseStudy => {
    const slug = getSlugName(caseStudy);
    return slug === 'cryptocurrency-lending-platform';
  });

  const responsive = [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 460,
      settings: {
        slidesToShow: 2
      }
    }
  ];

  return (
    <Layout
      title="Blockchain software development | Ulam Labs"
      description="Build your products and services with blockchain professionals. We use distributed ledger to build systems designed for your business needs."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Blockchain Development Services</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <ServicesHeading headingText={content.headingText} />
      <div className="telecommunication text-format padd-b pt-5">
        <Softwares content={content.softwaresText} />
      </div>
      <div className="container my-4 my-md-0 services-banner-top padd-t-sm">
        <Banner
          customTitle="Our approach to software development"
          customSubtitle="Find out how we develop services for our FinTech clients"
        />
      </div>
      <div className="result-show padd-t-sm version-pillar">
        <ResultTestimonial
          content={content.testimonialText}
          caseStudy={selectedCase}
          versionPillar
        />
      </div>
      <div className="my-5 crypto-result-card">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2 className="subtitle without bigger mb-0 pb-0">
                Blockchain projects we’ve delivered
              </h2>
            </div>
          </div>
        </div>
        <ResultsCardSwiperSection
          title="See related projects"
          buttonsAround={false}
          className="basis-slider"
          useSpecificCases={['cryptocurrency-lending-platform']}
          onlySlider
        />
      </div>
      <div className="container pb-5 horizontal-line pt-5">
        <div className="row">
          <div className="col-md-6">
            <div className="flex-column text-format">
              <h2 className="subtitle without bigger mb-3 pb-0">
                Benefits of blockchain technology for your business
              </h2>
              <ul className="m-0">
                {content.benefitsOfBlockchain.map(el => (
                  <li key={shortid.generate()}>{el}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-md-6 d-flex flex-column justify-content-center align-items-center mt-5 mt-md-0">
            <ImgHTML
              src={imagesPillarPages.blockchainIconSVG}
              alt="our company"
              style={{ objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>
      <div className="container pt-5 horizontal-line">
        <div className="row flex-column mb-4">
          <div className="col">
            <h2 className="subtitle bigger">{content.checkmarkText.title}</h2>
            <div className="content">
              <p>{content.checkmarkText.description}</p>
            </div>
          </div>
          <div className="col">
            <AniLink
              cover
              bg="#EAEBF1"
              to="/contact/"
              className="btn btn-main narrow my-4 mx-auto mx-md-0"
            >
              Let&apos;s work together
            </AniLink>
          </div>
        </div>
        <div className="icon-beam pt-2">
          <div className="row">
            <CheckmarkColumns
              checkmarkColumnsData={content.checkmarkColumnsData}
            />
          </div>
        </div>
      </div>
      <div className="container horizontal-line">
        <div className="row flex-column">
          <div className="container about-us">
            <div className="key-results" style={{ border: 'none' }}>
              <div className="item head">
                <div className="element">
                  <h3 className="mb-0">
                    We integrate with supplementary cryptocurrency services
                  </h3>
                </div>
              </div>
              <div className="item version-pillar swiper">
                <MultiCarousel slidesToShow={4} responsive={responsive}>
                  {content.carouselImages.map(img => {
                    return (
                      <div key={shortid.generate()}>
                        <OptimizedImage
                          src={img.src}
                          className="img-fluid"
                          style={{ width: '8rem' }}
                          alt={img.alt}
                          title={img.title}
                        />
                      </div>
                    );
                  })}
                </MultiCarousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TelecommunicationSection
        telecomSectionData={content.telecomSectionData1}
      />
      <div className="container py-5">
        <h2 className="subtitle bigger without">
          Why work with our blockchain developers?
        </h2>
        <div className="row work-with d-flex flex-column flex-md-row justify-content-between">
          <LandingPageInfoBox
            icon={imagesLandingPages.pythonSVG}
            title="Top Python blockchain developers"
            description="Ulam Labs has been developing services in Python programming language and blockchain technology - a perfect combination for any project."
          />
          <LandingPageInfoBox
            icon={imagesPillarPages.consultingSVG}
            title="Experienced engineers"
            description="Work daily with skilled and experienced blockchain developers."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.teamextensionSVG}
            title="Flexible collaboration"
            description="Get a dedicated team of blockchain developers full-time, part-time, or hourly. Scale up your team according to your needs."
          />
        </div>
        <div className="row work-with d-flex flex-column flex-md-row justify-content-between mb-3">
          <LandingPageInfoBox
            icon={imagesLandingPages.outcomeSVG}
            title="Excellent communication"
            description="Communication is as important for Ulam Labs as technical knowledge. You can be sure that we put effective and timely communication as one of our priorities."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.icon4SVG}
            title="Complementary services"
            description="In addition to blockchain development services, we have everything you need for a long-term, end-to-end tech partnership."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.ourroleSVG}
            title="Client's trust"
            description="More than 90% of our customers come back with their new projects and recommend our services."
          />
        </div>
      </div>
      <TelecommunicationSection
        versionBg
        telecomSectionData={content.telecomSectionData2}
      />
      <div className="version-pillar knowledge-services py-5 padd-big-b">
        <HomeKnowledge
          useSpecificPostsByTag={['Blockchain']}
          customTitle="Read about blockchain on our blog"
          customSubtitle="Our team of developers takes active part in creating educational
          and valuable content for our clients who are thinking about blockchain services. Read our blog to understand the technology
          better and know how to use distributed ledger to solve a variety of your business problems."
          versionPillar
        />
      </div>
      <div className="container my-4 my-md-0 services-banner-top">
        <Banner
          customTitle="Looking for blockchain developers for your project?"
          version="servicesPage"
        />
      </div>
      <div className="container-fluid" style={{ background: '#eaebf1' }}>
        <div className="version-pillar pb-5 padd-t container">
          <div className="info-box">
            <div style={{ background: '#eaebf1' }}>
              <h3 className="subtitle without bigger">
                What other services do we offer?
              </h3>
              <div className="row">
                <SingleBox
                  image={imagesPillarPages.graphSVG}
                  heading="Cryptocurrency & trading platforms"
                  url="/software-services/cryptocurrency-trading-platforms/"
                />
                <SingleBox
                  image={imagesLandingPages.pythonSVG}
                  heading="Python development"
                  url="/software-services/python-development/"
                />
                <SingleBox
                  image={imagesPillarPages.logoJS}
                  heading="JavaScript development"
                  url="/software-services/javascript-development/"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SoftwareServices;
